<div class="device-health-status__container" *ngIf="hasPermissionToViewHealthStatus">
  <div class="device-health-status__container__health-header">
    <span class="device-health-status__container__health-header__section" i18n="@@S_LIVEMAP_DEVICE_HEALTH">Device health</span>
    <span
      class="device-health-status__container__health-header__status"
      [fmTooltip]="this.vehicleHealthStatus?.healthStatus | deviceHealthIssueTooltip: this.deviceType"
      [ngClass]="this.healthCategoryCss"
      >{{ this.vehicleHealthStatus?.healthStatus | deviceHealthCategoryLocalizePipe }}</span
    >
  </div>
  <div class="device-health-status__container__health-issues-container" *ngIf="this.vehicleHealthStatus?.componentHealth.length > 0">
    <div *ngIf="!this.showComponentHealthMultipleError" class="device-health-status__container__health-issues-container__component">
      <mat-icon svgIcon="ic-health-status-critical" class="device-health-status__container__health-issues-container__component__icon">
      </mat-icon>
      <span class="device-health-status__container__health-issues-container__component__span"
        >{{ this.vehicleHealthStatus?.componentHealth[0].Observation | deviceHealthErrorLocalizePipe }}.
        <a
          (click)="onTrackerTroubleshoot()"
          a7s-id="live-map-balloon-tracker-issue-troubleshoot-click"
          i18n="@@S_LIVEMAP_HEALTH_TROUBLESHOOT"
          >Troubleshoot</a
        ></span
      >
    </div>
    <div
      *ngIf="!!this.vehicleHealthStatus?.componentHealth && this.showComponentHealthMultipleError"
      class="device-health-status__container__health-issues-container__component"
    >
      <mat-icon svgIcon="ic-health-status-critical" class="device-health-status__container__health-issues-container__component__icon">
      </mat-icon>
      <span class="device-health-status__container__health-issues-container__component__span" i18n="@@S_HEALTH_MULTI_TRACKER_ERROR"
        >Multiple tracker errors.</span
      ><a
        (click)="onTrackerTroubleshoot()"
        a7s-id="live-map-balloon-tracker-issue-troubleshoot-click"
        i18n="@@S_LIVEMAP_HEALTH_TROUBLESHOOT"
        >Troubleshoot</a
      >
    </div>
  </div>
  <div
    class="device-health-status__container__health-issues-container device-health-status__container__health-issues-container__camera"
    *ngIf="hasPermissionForCameras && this.vehicleHealthStatus?.cameraHealth.length > 0"
  >
    <div *ngIf="!this.showCameraHealthMultipleError" class="device-health-status__container__health-issues-container__component">
      <mat-icon svgIcon="ic-health-status-critical" class="device-health-status__container__health-issues-container__component__icon">
      </mat-icon>
      <span class="device-health-status__container__health-issues-container__component__span"
        >{{ this.vehicleHealthStatus?.cameraHealth[0].Observation | deviceHealthErrorLocalizePipe }}.
        <a (click)="onCameraTroubleshoot()" a7s-id="live-map-balloon-camera-issue-troubleshoot-click" i18n="@@S_LIVEMAP_HEALTH_TROUBLESHOOT"
          >Troubleshoot</a
        ></span
      >
    </div>

    <div *ngIf="this.showCameraHealthMultipleError" class="device-health-status__container__health-issues-container__component">
      <mat-icon svgIcon="ic-health-status-critical" class="device-health-status__container__health-issues-container__component__icon">
      </mat-icon>
      <span class="device-health-status__container__health-issues-container__component__span" i18n="@@S_HEALTH_MULTI_CAMERA_ERROR"
        >Multiple camera errors.</span
      ><a
        (click)="onCameraTroubleshoot()"
        a7s-id="live-map-balloon-camera-issue-troubleshoot-click"
        class="device-health-status__container__health-issues-container__component__troubleshoot"
        i18n="@@S_LIVEMAP_HEALTH_TROUBLESHOOT"
        >Troubleshoot</a
      >
    </div>
  </div>
</div>
